import { ShieldCheckIcon, ClockIcon, CurrencyDollarIcon, TrophyIcon, WrenchScrewdriverIcon, HeartIcon } from '@heroicons/react/24/solid';
import veteranBadge from '../assets/optimized/veteranbadge.webp';
import { useContent } from '../context/ContentContext';

const REASON_ICONS = [ShieldCheckIcon, ClockIcon, CurrencyDollarIcon, TrophyIcon, WrenchScrewdriverIcon, HeartIcon];

export default function WhyChooseUs() {
  const { content } = useContent();
  const wcu = content.whyChooseUs;

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-brand-off-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-1/3 h-1/3 bg-brand-orange/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-1/3 h-1/3 bg-brand-navy/5 rounded-full blur-3xl" />

      <div className="max-w-site mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 xl:gap-20 items-start">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28 xl:top-48">
              <div className="inline-flex items-center gap-2 border border-brand-orange/30 rounded-lg px-4 py-2 mb-6">
                <span className="w-2 h-2 bg-brand-orange rounded-full" />
                <span className="text-brand-orange font-semibold text-sm uppercase tracking-wider">
                  {wcu.sectionLabel}
                </span>
              </div>

              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-brand-navy mb-4 sm:mb-6">
                {wcu.heading}
              </h2>

              <p className="text-base sm:text-lg text-[#756c65] leading-relaxed mb-8 sm:mb-10">
                {wcu.description}
              </p>

              <div className="hidden sm:block relative mb-8 sm:mb-10">
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-brand-orange to-brand-orange/20 rounded-full" />
                <div className="pl-6 sm:pl-8">
                  <p className="text-lg sm:text-xl font-serif italic text-brand-navy leading-relaxed mb-3">
                    &quot;{wcu.quote}&quot;
                  </p>
                  <p className="text-sm font-semibold text-brand-orange tracking-wide uppercase">{wcu.quoteLabel}</p>
                </div>
              </div>

              <div className="hidden sm:flex items-center gap-5">
                <img decoding="async" loading="lazy" width={200} height={208}
                  src={veteranBadge}
                  alt="Veteran Owned Business"
                  className="w-20 sm:w-24 h-auto flex-shrink-0"
                />
                <div>
                  <h3 className="font-bold text-brand-navy text-base mb-0.5">{wcu.veteranHeading}</h3>
                  <p className="text-[#756c65] text-sm leading-relaxed">
                    {wcu.veteranDescription}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-5">
              {wcu.reasons.map((reason, index) => {
                const Icon = REASON_ICONS[index] || ShieldCheckIcon;
                return (
                  <div
                    key={index}
                    className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-7 group hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-brand-orange/20"
                  >
                    <div className="w-10 h-10 sm:w-14 sm:h-14 bg-brand-navy group-hover:bg-brand-orange rounded-lg sm:rounded-xl flex items-center justify-center mb-3 sm:mb-5 transition-colors duration-300">
                      <Icon className="w-5 h-5 sm:w-7 sm:h-7 text-white" />
                    </div>
                    <h3 className="font-bold text-brand-navy text-sm sm:text-lg mb-1 sm:mb-2">{reason.title}</h3>
                    <p className="text-brand-warm-gray text-xs sm:text-sm leading-relaxed">{reason.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
